import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=5269dbbd&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=ts"
export * from "./SaveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269dbbd",
  null
  
)

export default component.exports